import { render, staticRenderFns } from "./Safety.vue?vue&type=template&id=efee72de&scoped=true&"
import script from "./Safety.vue?vue&type=script&lang=js&"
export * from "./Safety.vue?vue&type=script&lang=js&"
import style0 from "./Safety.vue?vue&type=style&index=0&id=efee72de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efee72de",
  null
  
)

export default component.exports